import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { PlantLayoutAreaDrawingsTheme } from './themes/types';
import Button from '@plasma/ui.general.button';
import Select from '@plasma/ui.input.select';

const styled = baseStyled as ThemedStyledInterface<PlantLayoutAreaDrawingsTheme>;
const css = baseCss as ThemedCssFunction<PlantLayoutAreaDrawingsTheme>;

export const PlantLayoutAreaDrawings = styled.div`
  width: 100%;
  height: 100%;
`;

export const NormalPlasmaButton = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.mode.plantLayoutAreaDrawings.normalButtonBGColor} !important;
    border: ${theme.mode.plantLayoutAreaDrawings.normalButtonBorderColor} !important;
  `}
`;

export const NormalPlasmaSelect = styled(Select)`
  .ant-select-clear {
    margin-right: 1vw;
  }
    width: 100%;
`;

export const NormalButton = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.mode.plantLayoutAreaDrawings.normalButtonBGColor};
    border: ${theme.mode.plantLayoutAreaDrawings.normalButtonBorderColor};
  `}
  padding: 0.3vh 0.8vh;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div<{ showButtonBox: boolean }>`
  display: flex;
  flex-direction: column;
  position: ${({ showButtonBox }) => (showButtonBox ? 'relative' : 'fixed')};
  right: ${({ showButtonBox }) => (showButtonBox ? '' : '-14vw')};
  height: 88vh;
  margin:0.5vh;
  border: 2px solid #boccda;
  padding: 5px;
  border-radius: 5px;
  ${({ theme }) => css`
    background: ${theme.mode.plantLayoutAreaDrawings.buttonContainerBackground};
  `}
`;

export const ArrowButton = styled(Button)<{ showButtonBox: boolean }>`
  position: absolute !important;
  right: 13vw !important;
  border: 2px solid #267DAC !important;
  ${({ theme }) => css`
    background-color: ${theme.mode.plantLayoutAreaDrawings.arrowButtonBGColor} !important;
  `}
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0.5vh 0.5vh !important;
  border-radius: 5px !important;
  cursor: pointer !important;

  .icon {
    color: white !important;
  }
`;

export const ThemedButton = styled(Button)<{ isActive: boolean }>`
  margin: ${({ index }) => (index === 0 ? '4vh 0.5vw 0 0.7vw' : '2vh 0.5vw 0 0.7vw')} !important;
  width: 10vw;
  height: 5vh !important;
  border: 2px solid #267DAC !important;
  text-wrap: wrap;
  ${({ theme, isActive }) => css`
    color: ${isActive ? theme.mode.plantLayoutAreaDrawings.activeButtonTextColor : theme.mode.plantLayoutAreaDrawings.inactiveButtonTextColor} !important;
    background-color: ${isActive ? theme.mode.plantLayoutAreaDrawings.activeButtonBGColor : theme.mode.plantLayoutAreaDrawings.inactiveButtonBGColor} !important;
  `}
`;
